export class MoleculePanelOverviewHeaderMultiLockEmailActionComponent {
    public templateUrl = require('./multi-lock-email-action.html?external');
}
